import { PRODUCT_LINE_CODE } from '../../../constants/product-lines-codes';
import { SHIPPING_CONDITION_CODE } from '../../../constants/shipping-conditions-codes';
import { rmsWay } from '../../ways/rms.way';

export const repo = {
  [PRODUCT_LINE_CODE.READY_MIX]: {
    [SHIPPING_CONDITION_CODE.DELIVERY]: rmsWay,
  },
};
